function App() {
  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h1>Salom! MuhammadziyoGaming75 sayti!</h1>
      <p>Bu yerda o‘yinlar va AI xizmatlari bo‘ladi.</p>
    </div>
  );
}
export default App;
